import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, ShieldCheck, Lock } from "@phosphor-icons/react";

/**
 * FinalCTAV2 — CTA finale prima del footer. Verde salvia pieno,
 * promessa chiara, due bottoni: prova gratis + prova senza iscriverti.
 *
 * iter v31 r20 — Nuova landing.
 */
export default function FinalCTAV2() {
  const navigate = useNavigate();
  return (
    <section
      className="py-20 sm:py-32 bg-[#1C1C1A] text-white relative overflow-hidden"
      data-testid="final-cta-section"
    >
      <div
        className="absolute inset-0 pointer-events-none opacity-50"
        aria-hidden
      >
        <div
          className="absolute -top-20 -left-20 w-[400px] h-[400px] rounded-full blur-[120px]"
          style={{ background: "radial-gradient(circle, #7C8B6E40 0%, transparent 70%)" }}
        />
        <div
          className="absolute -bottom-20 right-0 w-[500px] h-[500px] rounded-full blur-[140px]"
          style={{ background: "radial-gradient(circle, #B57C5E20 0%, transparent 70%)" }}
        />
      </div>

      <div className="relative max-w-3xl mx-auto px-6 text-center">
        <span className="uppercase text-[11px] tracking-[0.22em] font-bold text-[#A8B89A]">
          Prova fino a ottobre
        </span>
        <h2 className="font-editorial text-[36px] sm:text-5xl lg:text-7xl mt-4 leading-[1.02] tracking-tighter">
          Le case le vendi tu,
          <br />
          <span className="italic text-[#A8B89A]">al resto ci pensa Pronto.</span>
        </h2>
        <p className="mt-7 text-[16px] sm:text-[18px] text-white/75 leading-relaxed max-w-xl mx-auto">
          Parli mentre giri la casa. Se in cinque minuti non hai l&apos;annuncio
          e le foto pronte da pubblicare, chiudi la scheda. Senza carta, senza
          impegno.
        </p>
        <p className="mt-3 text-[13px] sm:text-[14px] text-[#A8B89A] leading-snug max-w-xl mx-auto">
          Funziona dal browser, su computer o telefono. Non serve scaricare nulla.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
          <button
            onClick={() => navigate("/register")}
            className="inline-flex items-center justify-center gap-2 bg-white hover:bg-[#F1F4ED] text-[#1C1C1A] px-7 py-4 rounded-xl font-semibold text-[15px] transition-colors active:scale-[0.98]"
            data-testid="final-cta-primary"
          >
            Iscrizione gratuita
            <ArrowRight size={18} weight="bold" />
          </button>
          <button
            onClick={() => navigate("/prova")}
            className="inline-flex items-center justify-center gap-2 border border-white/25 hover:border-white text-white px-7 py-4 rounded-xl font-semibold text-[15px] transition-colors"
            data-testid="final-cta-secondary"
          >
            Provala senza iscriverti
          </button>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[12px] text-white/60">
          <span className="inline-flex items-center gap-1.5">
            <Lock size={13} weight="regular" />
            GDPR · Server in Europa
          </span>
          <span className="inline-flex items-center gap-1.5">
            <ShieldCheck size={13} weight="regular" />
            Watermark legale D.Lgs 70/2003
          </span>
        </div>
      </div>
    </section>
  );
}
